import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { OwnerVerificationStep } from '../HomePage/KYB/OwnerVerificationStep';

export function CustomerVerificationPage() {
  const { t } = useTranslation();

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Verification')}
          parent={{
            to: '/account/settings',
            title: t('Settings'),
          }}
        />
      }
      compact
    >
      <OwnerVerificationStep />
    </MainLayout>
  );
}
